export default "__VITE_ASSET__b1dd7728__"